// extracted by mini-css-extract-plugin
export default {"price":"b8-z","onSale":"c8-z","msrpLabelPrice":"d8-z","msrpLabel":"e8-z","originalPrice":"f8-z","percentOff":"g8-z"};